import { Translate } from '@hooks/useI18n';
import { getTranslatedData } from '@utils/getTranslatedData';
import { terminatedContractStatusKeys } from './constants';

export const getTerminatedContractStatusesTranslated = (translate: Translate) =>
  terminatedContractStatusKeys.map(
    key => getTranslatedData({ term: key, translate }) ?? '',
  );
